module.exports = __webpack_public_path__ + "static/logo-b30be797ffaa07596479862e9df61dfa.svg";